const list = [
  { name: 'Pessoa Jurídica', id: '2' },
  { name: 'Pessoa Física', id: '1' },
]

export default list;
